var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "gridcard rounded-card" },
      [
        _c(
          "v-flex",
          {
            attrs: {
              xs12: "",
              sm10: "",
              layout: "",
              wrap: "",
              "my-2": "",
              "py-4": ""
            }
          },
          [
            _c(
              "v-flex",
              { attrs: { xs12: "", sm4: "" } },
              [
                _c("v-text-field", {
                  attrs: { label: "Número", readonly: "" },
                  model: {
                    value: _vm.param.asignumero,
                    callback: function($$v) {
                      _vm.$set(_vm.param, "asignumero", $$v)
                    },
                    expression: "param.asignumero"
                  }
                })
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { xs12: "", sm4: "" } },
              [
                _c("DatePicker", {
                  attrs: { label: "Fecha", readonly: "" },
                  model: {
                    value: _vm.param.asigfecha_alta,
                    callback: function($$v) {
                      _vm.$set(_vm.param, "asigfecha_alta", $$v)
                    },
                    expression: "param.asigfecha_alta"
                  }
                })
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { xs12: "", sm4: "" } },
              [
                _c("v-text-field", {
                  attrs: { label: "Requerimiento", readonly: "" },
                  model: {
                    value: _vm.param.asigrequerimiento,
                    callback: function($$v) {
                      _vm.$set(_vm.param, "asigrequerimiento", $$v)
                    },
                    expression: "param.asigrequerimiento"
                  }
                })
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { xs12: "", sm4: "" } },
              [
                _c("v-text-field", {
                  attrs: { label: "Rut Cliente", readonly: "" },
                  model: {
                    value: _vm.param.rut_cliente,
                    callback: function($$v) {
                      _vm.$set(_vm.param, "rut_cliente", $$v)
                    },
                    expression: "param.rut_cliente"
                  }
                })
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { xs12: "", sm4: "" } },
              [
                _c("v-text-field", {
                  attrs: { label: "Cliente", readonly: "" },
                  model: {
                    value: _vm.param.cliente,
                    callback: function($$v) {
                      _vm.$set(_vm.param, "cliente", $$v)
                    },
                    expression: "param.cliente"
                  }
                })
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { xs12: "", sm4: "" } },
              [
                _c("v-text-field", {
                  attrs: { label: "Modalidad", readonly: "" },
                  model: {
                    value: _vm.param.modalidad,
                    callback: function($$v) {
                      _vm.$set(_vm.param, "modalidad", $$v)
                    },
                    expression: "param.modalidad"
                  }
                })
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { xs12: "", sm4: "" } },
              [
                _c("v-text-field", {
                  attrs: { label: "Flota", readonly: "" },
                  model: {
                    value: _vm.param.asigcrm_flota,
                    callback: function($$v) {
                      _vm.$set(_vm.param, "asigcrm_flota", $$v)
                    },
                    expression: "param.asigcrm_flota"
                  }
                })
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { xs12: "", sm4: "" } },
              [
                _c("v-text-field", {
                  attrs: { label: "Tipo Flota", readonly: "" },
                  model: {
                    value: _vm.param.ndvtipo_flota,
                    callback: function($$v) {
                      _vm.$set(_vm.param, "ndvtipo_flota", $$v)
                    },
                    expression: "param.ndvtipo_flota"
                  }
                })
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { xs12: "", sm4: "" } },
              [
                _c("v-text-field", {
                  attrs: { label: "Orden de Compra", readonly: "" },
                  model: {
                    value: _vm.param.asigordencompra,
                    callback: function($$v) {
                      _vm.$set(_vm.param, "asigordencompra", $$v)
                    },
                    expression: "param.asigordencompra"
                  }
                })
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { xs12: "", sm4: "" } },
              [
                _c("v-text-field", {
                  attrs: { label: "Manadante", readonly: "" },
                  model: {
                    value: _vm.param.asigmandanterut,
                    callback: function($$v) {
                      _vm.$set(_vm.param, "asigmandanterut", $$v)
                    },
                    expression: "param.asigmandanterut"
                  }
                })
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { xs12: "", sm4: "" } },
              [
                _c("v-text-field", {
                  attrs: { label: "Alta", readonly: "" },
                  model: {
                    value: _vm.param.asigcrm_alta,
                    callback: function($$v) {
                      _vm.$set(_vm.param, "asigcrm_alta", $$v)
                    },
                    expression: "param.asigcrm_alta"
                  }
                })
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { xs12: "", sm4: "" } },
              [
                _c("v-text-field", {
                  attrs: { label: "ADP", readonly: "" },
                  model: {
                    value: _vm.param.asigcrm_adp,
                    callback: function($$v) {
                      _vm.$set(_vm.param, "asigcrm_adp", $$v)
                    },
                    expression: "param.asigcrm_adp"
                  }
                })
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { xs12: "", sm4: "" } },
              [
                _c("v-text-field", {
                  attrs: { label: "Glosa Integración", readonly: "" },
                  model: {
                    value: _vm.param.glosa_integracion,
                    callback: function($$v) {
                      _vm.$set(_vm.param, "glosa_integracion", $$v)
                    },
                    expression: "param.glosa_integracion"
                  }
                })
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { xs12: "", sm4: "" } },
              [
                _c("v-text-field", {
                  attrs: { label: "Estado", readonly: "" },
                  model: {
                    value: _vm.param.estado,
                    callback: function($$v) {
                      _vm.$set(_vm.param, "estado", $$v)
                    },
                    expression: "param.estado"
                  }
                })
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { xs12: "", sm4: "" } },
              [
                _c("v-text-field", {
                  attrs: { label: "Tipo Creación", readonly: "" },
                  model: {
                    value: _vm.param.asigcreacion_auto,
                    callback: function($$v) {
                      _vm.$set(_vm.param, "asigcreacion_auto", $$v)
                    },
                    expression: "param.asigcreacion_auto"
                  }
                })
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { xs12: "", sm4: "" } },
              [
                _c("v-text-field", {
                  attrs: { label: "Porcentaje Finalización", readonly: "" },
                  model: {
                    value: _vm.param.porcentaje_serie,
                    callback: function($$v) {
                      _vm.$set(_vm.param, "porcentaje_serie", $$v)
                    },
                    expression: "param.porcentaje_serie"
                  }
                })
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { sm12: "" } },
              [
                _c("v-textarea", {
                  attrs: { label: "Nota", readonly: "" },
                  model: {
                    value: _vm.param.asignota,
                    callback: function($$v) {
                      _vm.$set(_vm.param, "asignota", $$v)
                    },
                    expression: "param.asignota"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }